import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';


const ReportFilters = ({ filters, onFiltersChange, onReset }) => {
  const dateRangeOptions = [
    { value: 'last-month', label: 'Last Month' },
    { value: 'last-quarter', label: 'Last Quarter' },
    { value: 'last-year', label: 'Last Year' },
    { value: 'ytd', label: 'Year to Date' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const categoryOptions = [
    { value: 'financial', label: 'Financial Overview' },
    { value: 'assets', label: 'Asset Analysis' },
    { value: 'income', label: 'Income Streams' },
    { value: 'expenses', label: 'Expense Tracking' },
    { value: 'projections', label: 'Future Projections' },
    { value: 'scenarios', label: 'Scenario Analysis' }
  ];

  const detailLevelOptions = [
    { value: 'summary', label: 'Executive Summary' },
    { value: 'standard', label: 'Standard Detail' },
    { value: 'comprehensive', label: 'Comprehensive' },
    { value: 'technical', label: 'Technical Analysis' }
  ];

  const formatOptions = [
    { value: 'pdf', label: 'PDF Document' },
    { value: 'excel', label: 'Excel Spreadsheet' },
    { value: 'csv', label: 'CSV Data Export' },
    { value: 'powerpoint', label: 'PowerPoint Presentation' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Report Filters</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          iconName="RotateCcw"
          iconPosition="left"
        >
          Reset
        </Button>
      </div>

      <div className="space-y-4">
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters.dateRange}
          onChange={(value) => onFiltersChange({ ...filters, dateRange: value })}
          placeholder="Select date range"
        />

        <Select
          label="Categories"
          description="Select report sections to include"
          options={categoryOptions}
          value={filters.categories}
          onChange={(value) => onFiltersChange({ ...filters, categories: value })}
          multiple
          searchable
          placeholder="Choose categories"
        />

        <Select
          label="Detail Level"
          options={detailLevelOptions}
          value={filters.detailLevel}
          onChange={(value) => onFiltersChange({ ...filters, detailLevel: value })}
          placeholder="Select detail level"
        />

        <Select
          label="Export Format"
          options={formatOptions}
          value={filters.format}
          onChange={(value) => onFiltersChange({ ...filters, format: value })}
          placeholder="Choose format"
        />
      </div>

      <div className="space-y-3">
        <h4 className="font-medium text-foreground">Additional Options</h4>
        <div className="space-y-2">
          <Checkbox
            label="Include Charts & Graphs"
            checked={filters.includeCharts}
            onChange={(e) => onFiltersChange({ ...filters, includeCharts: e.target.checked })}
          />
          <Checkbox
            label="Include Raw Data Tables"
            checked={filters.includeRawData}
            onChange={(e) => onFiltersChange({ ...filters, includeRawData: e.target.checked })}
          />
          <Checkbox
            label="Include Recommendations"
            checked={filters.includeRecommendations}
            onChange={(e) => onFiltersChange({ ...filters, includeRecommendations: e.target.checked })}
          />
          <Checkbox
            label="Include Scenario Comparisons"
            checked={filters.includeScenarios}
            onChange={(e) => onFiltersChange({ ...filters, includeScenarios: e.target.checked })}
          />
        </div>
      </div>

      <div className="pt-4 border-t border-border">
        <Button
          variant="default"
          fullWidth
          iconName="Filter"
          iconPosition="left"
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default ReportFilters;